export const REGEX = {
  EMAIL: /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+.[A-Za-z]{2,6}$/,
  PHONE: /^01(?:0|1|[6-9])[.-]?(\\d{3}|\\d{4})[.-]?(\\d{4})$/,
  DATE: /^(19[0-9][0-9]|20\d{2})-(0[0-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/,
  'YYYY-MM': /^(19[0-9][0-9]|20\d{2})-(0[0-9]|1[0-2])$/,
  PASSWORD: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^_])[A-Za-z\d!@#$%^_]{8,}$/,
};
